<template>
  <div>
    <div>
      <v-alert
          border="top"
          color="red lighten-2"
          :class = "color"
          dark
      >
        {{ validationErrors }}
      </v-alert>
    </div>

  </div>
</template>

<script>
export default {
  name: 'McvValidationErrors',
  props: {
    validationErrors: {
      type: [String, Object],
      required: true
    },
    color: {
      type: [String, Object],
      required: false
    }
  },
}
</script>
